import * as Yup from "yup";

const userSchema = Yup.object().shape({
  name: Yup.string("Debe ser una cadena de caracteres")
    .min(1, "No puede tener menos de 1 caracter")
    .max(50, "No puede tener más de 50 caracteres")
    .required("Ingrese el nombre"),
  lastName: Yup.string("Debe ser una cadena de caracteres")
    .min(1, "No puede tener menos de 1 caracter")
    .max(50, "No puede tener más de 50 caracteres")
    .required("Ingrese el nombre"),
  email: Yup.string("Debe ser una cadena de caracteres")
    .required("Ingrese su correo")
    .email("Debe ser un correo válido")
    .test(
      "no-dots-in-gmail",
      "El correo no puede tener . antes del @",
      (value) => {
        if (!value) return true; // Permitir campos vacíos si no es requerido
        const emailParts = value.split("@");
        if (
          emailParts.length === 2 &&
          emailParts[1].toLowerCase() === "gmail.com"
        ) {
          return !emailParts[0].includes(".");
        }
        return true; // Si no es Gmail, permitir cualquier cosa
      }
    ),
  phone: Yup.string("Debe ser una cadena de caracteres")
    .min(6, "No puede tener menos de 6 caracteres")
    .max(20, "No puede tener más de 20 caracteres"),
  username: Yup.string("Debe ser una cadena de caracteres")
    .min(1, "No puede tener menos de 1 caracter")
    .max(50, "No puede tener más de 50 caracteres")
    .required("Ingrese el nombre de usuario"),
  otp_attempt: Yup.string().when("otp_required_for_login", {
    is: true,
    then: Yup.string().required("Ingrese su código de autenticación"),
  }),
});

const requiredPassSchema = Yup.object().shape({
  password: Yup.string()
    .min(12, "La contraseña debe tener al menos 12 caracteres")
    .max(128, "La contraseña no puede tener más de 128 caracteres")
    .matches(/[a-z]/, "Debe contener al menos una letra minúscula")
    .matches(/[A-Z]/, "Debe contener al menos una letra mayúscula")
    .matches(/\d/, "Debe contener al menos un número")
    .matches(
      /[@$!%*?&]/,
      "Debe contener al menos un carácter especial (@, $, !, %, *, ?, &)"
    )
    .required("La contraseña es obligatoria"),
  confirmationPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir")
    .required("Por favor confirma la contraseña"),
});

const optionalPassSchema = Yup.object({
  password: Yup.string()
    .min(12, "La contraseña debe tener al menos 12 caracteres")
    .max(128, "La contraseña no puede tener más de 128 caracteres")
    .matches(/[a-z]/, "Debe contener al menos una letra minúscula")
    .matches(/[A-Z]/, "Debe contener al menos una letra mayúscula")
    .matches(/\d/, "Debe contener al menos un número")
    .matches(
      /[@$!%*?&]/,
      "Debe contener al menos un carácter especial (@, $, !, %, *, ?, &)"
    )
    .optional(),

  confirmationPassword: Yup.string()
    .test(
      "passwords-match",
      "Las contraseñas deben coincidir",
      function (value) {
        const { password } = this.parent;
        if (password) {
          return password === value;
        }
        return true; // No hace la validación si `password` está vacío
      }
    )
    .test("password-required", "Confirma tu contraseña", function (value) {
      const { password } = this.parent;
      return !password || (password && value); // Solo requerido si `password` tiene valor
    }),

  currentPassword: Yup.string().test(
    "current-password-required",
    "Debes ingresar tu contraseña actual",
    function (value) {
      const { password } = this.parent;
      // Solo requiere `currentPassword` si `password` tiene un valor
      return !password || (password && value);
    }
  ),
});

const optionalPassWithoutCurrentPassSchema = Yup.object().shape({
  password: Yup.string()
    .min(12, "La contraseña debe tener al menos 12 caracteres")
    .max(128, "La contraseña no puede tener más de 128 caracteres")
    .matches(/[a-z]/, "Debe contener al menos una letra minúscula")
    .matches(/[A-Z]/, "Debe contener al menos una letra mayúscula")
    .matches(/\d/, "Debe contener al menos un número")
    .matches(
      /[@$!%*?&]/,
      "Debe contener al menos un carácter especial (@, $, !, %, *, ?, &)"
    )
    .optional(),
  confirmationPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir")
    .optional(),
});

export const newUserSchema = userSchema.concat(
  optionalPassWithoutCurrentPassSchema
);
export const editUserSchema = userSchema.concat(optionalPassSchema);

export default requiredPassSchema;
